import { render, staticRenderFns } from "./SendJsonResponse.vue?vue&type=template&id=68211dc4"
import script from "./SendJsonResponse.vue?vue&type=script&lang=js"
export * from "./SendJsonResponse.vue?vue&type=script&lang=js"
import style0 from "./SendJsonResponse.vue?vue&type=style&index=0&id=68211dc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports